import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { ModalModule } from 'ngx-bootstrap';
import { Http, Response } from '@angular/http';
import { INascarViewModel } from '../models/INascarViewModel';
import { IDriver } from '../models/IDriver';
import { ISeason } from '../models/ISeason';
import { IWeek } from '../models/IWeek';
import { NascarService } from '../services/nascar.service';
import { AlertService } from '../services/alert.service';
import { BaseService } from '../services/base.service';
import { AuthService } from '../account/auth.service';
import { INascarSeasonTotal } from '../models/INascarSeasonTotal';
import { IOrgUserRaceFilter } from '../models/IOrgUserRaceFilter'

@Component({
  selector: 'app-nascarresults',
  templateUrl: './nascarresults.component.html',
  styleUrls: ['./nascarresults.component.scss']
})
export class NascarResultsComponent implements OnInit {

  public nascarResults: INascarViewModel[];
  // public currentWeek: IWeek;
  // public currentSeason: ISeason;
  public seasons: ISeason[];
  public weeks: IWeek[];
  public nascarSeasonResults: INascarSeasonTotal[];
  public orgUserRaceFilter: IOrgUserRaceFilter = {};
  public status: { isOpen: boolean } = { isOpen: false };
  // todo: remove hard code!!!!
  // public currentOrg: string = "5a7b7aff6847bb036c9429e2";
  public isDropup: boolean = true;
  public autoClose: boolean = false;

  constructor(private alertService: AlertService,
              private nascarService: NascarService,
              private authService: AuthService,
              private baseService: BaseService) {

  }

  ngOnInit() {
    //this.orgUserRaceFilter.friendlyName = "Test";
    this.orgUserRaceFilter.orgId = "5a7b7aff6847bb036c9429e2";
    //this.orgUserRaceFilter.friendlyName = this.authService.user.friendlyName;

    this.getSeasons();
    //this.getWeeks(this.currentSeason);

    this.nascarService.getCurrentRaceResults()
      .subscribe(result => {
        this.nascarResults = result as INascarViewModel[];
        // this.currentWeek = this.nascarResults[0].weekNumber;
        this.nascarResults.sort((a, b) => b.points - a.points);
      });
      this.getRaceSeasonResults();
    // this.nascarService.getRaceSeasonResults(this.orgUserRaceFilter);
  }

  change(value: boolean): void {
    this.status.isOpen = value;
  }

  getSeasons() {
    this.nascarService.getSeasons()
      .subscribe(result => {
        this.seasons = result as ISeason[];
        this.seasons.sort((a, b) => b.name- a.name);
        this.orgUserRaceFilter.season = this.seasons[0].name;
        this.getWeeks();
      });
  }

  getWeeks() {

    this.nascarService.getWeeks(this.orgUserRaceFilter)
      .subscribe(result => {
        this.weeks = result as IWeek[];
        this.weeks.sort((a, b) => b.name - a.name);
        this.orgUserRaceFilter.weekNumber = this.weeks[0].name;
      });
  }

  setCurrentSeason($event: MouseEvent, season) {
    this.orgUserRaceFilter.season = season.name;
    this.getRaceResults();
    this.getRaceSeasonResults();
    
  }

  setCurrentWeek($event: MouseEvent, week) {
    
    this.orgUserRaceFilter.weekNumber = week.name;
    this.getRaceResults();
    
  }

  getRaceResults() {
    this.nascarService.getRaceResults(this.orgUserRaceFilter)
    .subscribe(result => {
      this.nascarResults = result as INascarViewModel[];
      this.nascarResults.sort((a, b) => b.points - a.points);
    });
  }
  getRaceSeasonResults() {
    this.nascarService.getRaceSeasonResults(this.orgUserRaceFilter)
    .subscribe(result => {
      this.nascarSeasonResults = result as INascarSeasonTotal[];
      this.nascarSeasonResults.sort((a, b) => b.points - a.points);
    });
  }

}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/nascarresults/nascarresults.component.ts